import React, { useEffect, useState } from 'react';
import { Dimensions, Platform, ScrollView, TouchableOpacity } from 'react-native';

import {
  VFScreen,
  ErrorScreen,
  VFText,
  Icon,
  IconTypes,
} from '@vfgroup-oneplatform/foundation/Components';
import { ShimmerWrapper } from '@vfgroup-oneplatform/foundation/Components/Shimmer';
import { LightThemeColors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { TypesList } from '@vfgroup-oneplatform/foundation/Components/Themes/Types';
import ContentManager from '@vfgroup-oneplatform/foundation/ContentManager';
import { dateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils/dateCurrencyFormate';
import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import { paymentBreakDownLoadingConfig } from '../../Common/LoadingConfigurations/PaymentBreakdownLoading/PaymentBreakdownLoading.config';
import {
  SubscriptionsList,
  VfView,
  PaymentInfo,
  HeadLine,
  NegativeBillQuickAction,
} from '../../Components';
import MonthlyBillingQAM from '../../Components/MonthlyBillingQAM/MonthlyBillingQAM';
import { getThemeImages, Images } from '../../Themes';
import { BillingTrackingManager, Helpers } from '../../Utils';
import BillingTestKeys from '../../Utils/BillingTestKeys.js';
import { Bill_Status, getBillStatusName } from '../../Utils/BillStatus.Enum';
import { Error_Types } from '../../Utils/ErrorTypes.Enum';
import useMonthlyBillingQAM from '../../Utils/useMonthlyBillingQAM';

import { headerLoadingConfig } from './LoadingConfigurations/HeaderLoading.config';
import styles from './MonthlyBilling.Styles';

const expansionPanelLoader = (numberOfLoadingCards, theme) => {
  const loadingCards = [];
  const loadingCard = (
    <ShimmerWrapper
      isLoading={true}
      loadingConfig={paymentBreakDownLoadingConfig}
      containerStyle={styles.cardStyle(theme)}
    />
  );
  for (let i = 0; i < numberOfLoadingCards; i++) {
    loadingCards.push(loadingCard);
  }
  return loadingCards;
};

const renderHeaderLoading = (header, isLoading, loaderStyle) => {
  return header && header.loader ? (
    header.loader
  ) : (
    <ShimmerWrapper isLoading={isLoading} loadingConfig={headerLoadingConfig(loaderStyle)} />
  );
};

const renderSubHeaderAfterSubTitle = status => {
  let subTitleStatus = ' ';
  switch (status) {
    case Bill_Status.SENT:
    case Bill_Status.SETTLED:
    case Bill_Status.PARTIALLY_PAID:
      subTitleStatus = 'billing_details_total_spend';
      break;
    case Bill_Status.NEW:
    case Bill_Status.ON_HOLD:
    case Bill_Status.VALIDATED:
      subTitleStatus = 'billing_current_spend';
      break;
    default:
      break;
  }
  return subTitleStatus;
};

const renderSubHeaderDesciption = payment => {
  const { status, value, currency, paidValue, isLoading } = payment;
  if (status === Bill_Status.PARTIALLY_PAID && !isLoading) {
    const remainValue = dateCurrencyFromatter.currencyTransformer(value - paidValue);
    return ContentManager.translate('billing_details_partially_paid_remaining', [
      `${dateCurrencyFromatter.currencyTransformer(paidValue)}`,
      `${remainValue}${currency}`,
    ]);
  }
};

const renderSubscriptionsList = ({
  subscriptions,
  withCTA,
  ctaProps,
  renderBreakDownItem,
  errorType,
  theme,
  toggleModal,
}) => {
  if (_.isEmpty(subscriptions)) {
    return null;
  }

  return (
    <>
      <VfView style={styles.marginBetweenComponents}>
        <VFText
          style={styles.billBreakDownText(theme)}
          i18nKey={'billing_payment_breakdown_title'}
          testKey={BillingTestKeys.billingPaymentBreakdownTitleText}
        />
      </VfView>

      {_.get(subscriptions, 'isError', false) && errorType === Error_Types.PARTIAL_ERROR ? (
        <ErrorScreen
          text="billing_payment_breakdown_error_text"
          textButton="billing_payment_breakdown_error_try_again_button"
          backgroundStyle={styles.errorPreviousBillsBackgroundStyle}
          iconStyle={styles.errorPreviousBillsIconStyle}
          onPress={_.get(subscriptions, 'onTryAgainPress', undefined)}
        />
      ) : null}

      {_.get(subscriptions, 'isLoading', false) && !_.get(subscriptions, 'isError', false) ? (
        expansionPanelLoader(2, theme)
      ) : (
        <SubscriptionsList
          subscriptions={subscriptions?.data}
          onShowMorePress={subscriptions.onShowMorePress}
          withCTA={withCTA}
          ctaProps={ctaProps}
          renderBreakDownItem={renderBreakDownItem}
          toggleModal={toggleModal}
        />
      )}
    </>
  );
};

const sendTrackingInfo = (
  payment,
  billEndDate,
  getAdditionalTrackingInfo,
  isBillBreakdownSection,
) => {
  const billStatus = getBillStatusName(payment.status);
  const data = {
    page_name: 'Billing:BillDetails',
    page_section: 'Billing:BillDetails',
    transaction_status: billStatus,
    visitor_bill_amount_current_active: payment?.value,
    visitor_bill_date_due_current_active: moment(billEndDate).format('YYYYMMDD'),
  };

  const additionalData = _.isFunction(getAdditionalTrackingInfo) && getAdditionalTrackingInfo();

  // if (isBillBreakdownSection) {
  //   BillingTrackingManager.trackView('(Scrolled) - Bill detail page', {
  //     ...data,
  //     page_section: 'Billing: Bill Breakdown',
  //     ...additionalData,
  //   });
  // } else {
  //   BillingTrackingManager.trackView('Bill detail page (3rd level)', {
  //     ...data,
  //     ...additionalData,
  //   });
  //   if (payment.status === Bill_Status.NEW || payment.status == Bill_Status.PARTIALLY_PAID) {
  //     BillingTrackingManager.trackView(`3rd level / ${billStatus} bill`, {
  //       ...data,
  //       page_section: 'Billing: Bill Breakdown',
  //       ...additionalData,
  //     });
  //   } else {
  //     BillingTrackingManager.trackView(`3rd level / ${billStatus}`, {
  //       ...data,
  //       page_section: 'Billing: Bill Breakdown',
  //       ...additionalData,
  //     });
  //   }
  // }
};

const onScrollHandling = (
  { nativeEvent },
  isTrackingEventSent,
  setIsTrackingEventSent,
  getAdditionalTrackingInfo,
  payment,
  billEndDate,
) => {
  // if (nativeEvent.contentOffset.y >= 300 && !isTrackingEventSent) {
  //   sendTrackingInfo(payment, billEndDate, getAdditionalTrackingInfo, true);
  //   setIsTrackingEventSent(true);
  // }
};
const renderNegativeBillIcon = (
  billingNegativeValueNote,
  billingNegativeValueNoteStyle,
  toggleNegativeBillModal,
  themeImages,
  theme,
) => {
  return (
    <TouchableOpacity
      onPress={toggleNegativeBillModal}
      activeOpacity={1}
      hitSlop={{
        top: 10,
        left: 10,
        bottom: 10,
        right: 10,
      }}
      testID={BillingTestKeys.monthlyBillingNegativeBillTO}
    >
      <VfView
        style={styles.negativeBalanceContainer}
        row
        testID={BillingTestKeys.monthlyBillingNegativeBillView}
      >
        {!!billingNegativeValueNote && (
          <VFText
            i18nKey={billingNegativeValueNote}
            style={[styles.negativeBalanceText(theme), billingNegativeValueNoteStyle]}
            testKey={BillingTestKeys.monthlyBillingNegativeBillNoteText}
          />
        )}
        <Icon
          source={themeImages.icInfoRed}
          type={IconTypes.image}
          size={22}
          style={styles.icon}
          testID={BillingTestKeys.monthlyBillingNegativeBillIcon}
        />
      </VfView>
    </TouchableOpacity>
  );
};

function MonthlyBilling(props) {
  const {
    vfScreen,
    header,
    payment,
    subscriptions,
    headline,
    withTray,
    renderBreakDownItem,
    renderSubscriptions,
    renderFooter,
    withCTA,
    ctaProps,
    theme,
    errorType,
    isError,
    withSubHeader,
    fullErrorScreenProps,
    getAdditionalTrackingInfo,
    billEndDate,
    renderSectionAfterPaymentInfo,
    paymentInfoContainerStyle,
    autoBillStatusProps,
    customButtonsProps,
    withPayButton,
    billAmountStyle,
    negativeBillQuickActionsProps = {},
    withSubHeaderAfterSubtitle,
    scrollRef,
    renderSubHeaderAfterSubTitle: _renderSubHeaderAfterSubTitle,
  } = props;
  const [isBillBreakdownTrackingEventSent, setIsBillBreakdownTrackingEventSent] = useState(false);
  const [isInitialTrackingEventSent, setIsInitialTrackingEventSent] = useState(false);
  const [isNegativeBillModalVisible, setIsNegativeBillModalVisible] = useState(false);
  useEffect(() => {
    if (payment?.price && !payment?.isLoading && !payment?.isError && !isInitialTrackingEventSent) {
      // sendTrackingInfo(payment, billEndDate, getAdditionalTrackingInfo);
      // setIsInitialTrackingEventSent(true);
    }
  }, [payment]);
  const qaConfig = useMonthlyBillingQAM();
  const toggleModal = qaConfig.toggleModal;
  const customSubtitle = _.get(header, 'customSubtitle', '');
  const customSubHeaderTitle = _.get(header, 'customSubHeaderTitle', '');
  const customSubtitleStyle = _.get(header, 'customSubtitleStyle', {});
  const customSubHeaderAfterSubTitleStyle = _.get(header, 'customSubHeaderAfterSubTitleStyle', {});
  const customSubHeaderTitleStyle = _.get(header, 'customSubHeaderTitleStyle', {});
  const customHeaderStyle = _.get(header, 'customHeaderStyle', {});
  const statusBarProps = _.get(header, 'statusBarProps', {});
  const subHeaderFullContainerStyle = _.get(header, 'subHeaderFullContainerStyle', {});
  const themeImages = getThemeImages(theme.name);
  const isRenderSubHeaderAfterSubTitleFunction = _.isFunction(_renderSubHeaderAfterSubTitle);

  const subscriptionsState = subscriptions && !subscriptions.isLoading;
  const paymentState = payment && !payment.isLoading;
  const isScrollEnabled = subscriptionsState || paymentState;

  const getSubHeaderTitle = () => {
    if (customSubHeaderTitle) {
      return customSubHeaderTitle;
    }
    return 'billing_details_title';
  };

  const getSubHeaderSubTitle = () => {
    if (customSubtitle) {
      return customSubtitle;
    }
    if (header) {
      return header.subTitle;
    }
  };

  const renderSubscriptionsSection = () => {
    if (_.isFunction(renderSubscriptions)) {
      return renderSubscriptions(subscriptions);
    } else {
      return renderSubscriptionsList({
        subscriptions,
        withCTA,
        ctaProps,
        renderBreakDownItem,
        theme,
        errorType,
        toggleModal,
      });
    }
  };
  const renderPaymentInfoSection = () => {
    if (isError && errorType === Error_Types.FULL_ERROR) {
      return <ErrorScreen {...fullErrorScreenProps} />;
    }
    return (
      <VfView xs={Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 12 : 11}>
        {payment && (
          <VfView style={[styles.paymentInfoContainer, paymentInfoContainerStyle]}>
            <PaymentInfo
              codeLabel={'billing_client_code'}
              billNumberLabel={'billing_bill_number'}
              paymentMethodLabel={'billing_payment_method'}
              billStatusLabel={'billing_client_status'}
              toBePaidLabel={'billing_dashboard_due_date_args'}
              billEndDate={billEndDate}
              withPayButton={withPayButton}
              customButtonsProps={customButtonsProps}
              {...autoBillStatusProps}
              {...payment}
              {...theme}
            />
          </VfView>
        )}

        {_.isFunction(renderSectionAfterPaymentInfo) && renderSectionAfterPaymentInfo()}
        {renderSubscriptionsSection()}

        {headline && (
          <VfView style={styles.marginBetweenComponents}>
            <HeadLine {...headline} />
          </VfView>
        )}

        {_.isFunction(renderFooter) && renderFooter()}
      </VfView>
    );
  };

  return (
    <VFScreen
      {...vfScreen}
      withSubHeader={!!header && withSubHeader}
      statusBarProps={statusBarProps}
      headerStyle={customHeaderStyle}
      subHeaderFullContainerStyle={[
        styles.subHeaderFullContainerStyle,
        subHeaderFullContainerStyle,
      ]}
      renderAftersubHeaderAfterSubTitle={() =>
        negativeBillQuickActionsProps.withBillNegativeAlertIcon &&
        renderNegativeBillIcon(
          negativeBillQuickActionsProps.billingNegativeValueNote,
          negativeBillQuickActionsProps.billingNegativeValueNoteStyle,
          setIsNegativeBillModalVisible,
          themeImages,
          theme,
        )
      }
      subHeaderSubTitle={getSubHeaderSubTitle()}
      subHeaderTitle={getSubHeaderTitle()}
      subHeaderTitleStyle={customSubHeaderTitleStyle ?? {}}
      subHeaderTitlePlaceholders={header && [header.title]}
      subHeaderSubTitleStyle={
        customSubtitleStyle
          ? [customSubtitleStyle, billAmountStyle]
          : Helpers.splitStringBySpace(_.get(header, 'subTitle', '0 €'))[0] < 0
            ? [styles.billPriceStyle, billAmountStyle]
            : undefined
      }
      subHeaderAfterSubTitle={
        (!customSubtitle || isRenderSubHeaderAfterSubTitleFunction) &&
        header &&
        withSubHeaderAfterSubtitle &&
        (isRenderSubHeaderAfterSubTitleFunction
          ? _renderSubHeaderAfterSubTitle(header.status)
          : renderSubHeaderAfterSubTitle(header.status))
      }
      subHeaderAfterSubTitleStyle={[
        styles.subHeaderAfterSubTitle,
        customSubHeaderAfterSubTitleStyle,
      ]}
      subHeaderDescription={payment && renderSubHeaderDesciption(payment)}
      subHeaderDescriptionContainerStyle={styles.subHeaderDescriptionStyle(
        payment && payment.isLoading,
      )}
      renderDescriptionInfo={
        payment &&
        !payment.isError &&
        payment.isLoading &&
        payment.status === Bill_Status.PARTIALLY_PAID &&
        (() => renderHeaderLoading(header, payment.isLoading, styles.descriptionInfoLoaderStyle))
      }
      subHeaderTitleAccessibilityLabel={BillingTestKeys.monthlyBillingScreenSubHeaderTitleText}
      titleTextAccessibilityLabel={BillingTestKeys.monthlyBillingScreenTitleText}
      subHeaderSubTitleAccessibilityLabel={
        BillingTestKeys.monthlyBillingScreenSubHeaderSubTitleText
      }
      backButtonTestID={BillingTestKeys.monthlyBillingScreenBackBtn}
      closeButtonTestID={BillingTestKeys.monthlyBillingScreenCloseBtn}
    // withHeaderSpace
    >
      <ScrollView
        contentContainerStyle={[
          styles.containerStyle(payment && payment.status === Bill_Status.PARTIALLY_PAID),
          withTray ? styles.scrollViewContentContainerStyle : undefined,
          { paddingHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '10%' : 0 }
        ]}
        bounces={false}
        scrollEnabled={isScrollEnabled && !isError}
        onScroll={event =>
          onScrollHandling(
            event,
            isBillBreakdownTrackingEventSent,
            setIsBillBreakdownTrackingEventSent,
            getAdditionalTrackingInfo,
            payment,
            billEndDate,
          )
        }
        testID="MonthlyBillingScroll"
        ref={scrollRef}
        scrollEventThrottle={16}
      >
        <MonthlyBillingQAM {...qaConfig} />
        <VfView justify="center" alignItems="center">
          {renderPaymentInfoSection()}
        </VfView>
      </ScrollView>
      <NegativeBillQuickAction
        isVisible={negativeBillQuickActionsProps.isVisible || isNegativeBillModalVisible}
        toggleModal={
          negativeBillQuickActionsProps.toggleNegativeBillModal || setIsNegativeBillModalVisible
        }
        closeModal={
          negativeBillQuickActionsProps.closeNegativeBillModal || setIsNegativeBillModalVisible
        }
        icon={negativeBillQuickActionsProps.icon || Images.icInfoCircleGrey}
        QAtitle={
          negativeBillQuickActionsProps.QAtitle || 'billing_negative_bill_quick_action_title'
        }
        title={
          negativeBillQuickActionsProps.title || 'billing_negative_bill_quick_action_question_text'
        }
        description={
          negativeBillQuickActionsProps.description ||
          'billing_negative_bill_quick_action_description'
        }
        buttonTitle={
          negativeBillQuickActionsProps.buttonTitle ||
          'billing_negative_bill_quick_action_button_text'
        }
        getAdditionalTrackingInfo={negativeBillQuickActionsProps.getAdditionalTrackingInfo}
        {...negativeBillQuickActionsProps}
      />
    </VFScreen>
  );
}

MonthlyBilling.defaultProps = {
  withTray: false,
  theme: LightThemeColors,
  withSubHeaderAfterSubtitle: true,
  withSubHeader: true,
  errorType: Error_Types.PARTIAL_ERROR,
};

MonthlyBilling.propTypes = {
  vfScreen: PropTypes.object,
  header: PropTypes.object,
  payment: PropTypes.object,
  subscriptions: PropTypes.object,
  headline: PropTypes.object,
  navigationBar: PropTypes.object,
  title: PropTypes.string,
  background: PropTypes.any,
  withTray: PropTypes.bool,
  renderSubHeaderAfterSubTitle: PropTypes.func,
  withExtraCard: PropTypes.bool,
  renderExtraCardContent: PropTypes.func,
  withCTA: PropTypes.bool,
  ctaProps: PropTypes.object,
  isLoading: PropTypes.bool,
  isError: PropTypes.bool,
  withSubHeader: PropTypes.bool,
  errorType: PropTypes.oneOfType(Error_Types),
  fullErrorScreenProps: PropTypes.object,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  renderBreakDownItem: PropTypes.func,
  renderFooter: PropTypes.func,
  renderSubscriptions: PropTypes.func,
  getAdditionalTrackingInfo: PropTypes.func,
  billEndDate: PropTypes.string,
  renderSectionAfterPaymentInfo: PropTypes.func,
  paymentInfoContainerStyle: ViewPropTypes.style,
  autoBillStatusProps: PropTypes.shape({
    fullAutoPaymentDate: PropTypes.array,
    isCurrentBill: PropTypes.bool,
    isAutoBillActivated: PropTypes.bool,
    withAutoBillStatus: PropTypes.bool,
  }),
  customButtonsProps: PropTypes.array,
  withPayButton: PropTypes.bool,
  withSubHeaderAfterSubtitle: PropTypes.bool,
  billAmountStyle: PropTypes.object,
  negativeBillQuickActionsProps: PropTypes.shape({
    QAtitle: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    buttonTitle: PropTypes.string,
    icon: PropTypes.string,
    isVisible: PropTypes.bool,
    billingNegativeValueNote: PropTypes.string,
    billingNegativeValueNoteStyle: PropTypes.object,
    withBillNegativeAlertIcon: PropTypes.bool,
    withCloseButton: PropTypes.bool,
    buttonStyle: PropTypes.object,
    QAtitleStyle: PropTypes.object,
    titleStyle: PropTypes.object,
    descriptionStyle: PropTypes.object,
    descriptionContainerStyle: PropTypes.object,
    buttonType: PropTypes.oneOf(TypesList),
  }),
  scrollRef: PropTypes.object
};

export default withTheme(MonthlyBilling);
export {
  expansionPanelLoader,
  renderHeaderLoading,
  renderSubHeaderAfterSubTitle,
  renderSubHeaderDesciption,
  renderSubscriptionsList,
  sendTrackingInfo,
  onScrollHandling,
};
